<template>
  <div class="mb-8">

  <!-- Legenda -->
    <div class="icone-legenda">
      <v-col class="text-center" cols="12">
        <v-card height="35" width="35" rounded>
          <div>
            <v-tooltip bottom>
              <template style="
                  display: flex;
                  align-items: center;
                  justify-items: center;
              "
               v-slot:activator="{ on, attrs }">
                <v-icon style="margin-top:5px" v-bind="attrs" v-on="on" color="#283593" fab>mdi-information-outline</v-icon>
              </template>
              <div><span class="centralizaLegenda"><span class="quadradoLegenda"
                    style="color: #037CD6;">&#9632;</span>Online</span></div>
              <div><span class="centralizaLegenda"><span class="quadradoLegenda"
                    style="color: #2C9437;">&#9632;</span>Disponível</span></div>
              <div><span class="centralizaLegenda"><span class="quadradoLegenda"
                    style="color: #D3201F;">&#9632;</span>Ocupado</span></div>
              <div><span class="centralizaLegenda"><span class="quadradoLegenda"
                    style="color: #FFB301;">&#9632;</span>Pausado</span></div>
              <div><span class="centralizaLegenda"><span class="quadradoLegenda"
                    style="color: #FB8C00;">&#9632;</span>Lig. em Espera</span></div>
              <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #C2C2C2;">&#9632;
                  </span>Indisponível</span></div>
            </v-tooltip>
          </div>
        </v-card>
      </v-col>
    </div>

   <!-- Opções -->
    <div class="filter-peers">
      <v-col class="text-right" cols="12">
        <v-card height="50" width="480" rounded v-show="!hideButtons">
          <div class="filter-peers-active">
            <i @click="hideButtons = !hideButtons" class="material-icons hide-filter-peers">chevron_right</i>
            <v-switch v-model="livres" dense label="Livres" class="mr-4" />
            <v-switch v-model="emLigacao" dense label="Em Ligação" class="mr-4" />
            <v-switch v-model="indisponiveis" dense label="Indisponíveis" />
          </div>
        </v-card>

        <v-card height="30" width="20" rounded v-show="hideButtons">
          <i @click="hideButtons = !hideButtons" class="material-icons icon-show-filters">chevron_left</i>
        </v-card>
      </v-col>
    </div>

    <v-row dense class="ml-4 mt-4">
      <v-card class="mr-4 mb-4" width="256" height="110" v-for="(call, key) in getArrayRamaisFiltrados" :key="key">
        <div :class="`app-bar-card-monitor ${selectColor(call)}`">
          <div class="peer-number-name text-app-bar">
            {{ limitaNumeroDeCaracteres(call.deviceId) }}
          </div>
        </div>

        <div class="body-card-monitor">
          <div class="pause-or-calls-card-monitor">
            <i class="material-icons next-previous-call-icon" @click="nextCall(call.deviceId)"
              v-show="typeof call.channels !== 'undefined' && call.channels.length > 1">
              chevron_left
            </i>

            <div class="time-and-calls-text-card-monitor">
              {{
                typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 0
                  ? call.channels[call.callIndex].phoneNumber
                  : ''
              }}
            </div>

            <div class="time-and-calls-text-card-monitor">
              {{
                typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 0
                  ? mostraTempo(call.channels, call.callIndex)
                  : call.time
              }}
            </div>

            <i class="material-icons next-previous-call-icon" @click="nextCall(call.deviceId)"
              v-show="typeof call.channels !== 'undefined' && call.channels.length > 1">
              chevron_right
            </i>
          </div>

          <div class="icons-and-calls-card-monitor">
            <div class="qtd-calls-operator-card-body color-icons-qtd-calls-card-body"
              v-show="typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 0">
              {{ verificaLigacoes(call.channels) }}
            </div>

            <i class="material-icons icon-operator-card-body color-icons-qtd-calls-card-body"
              v-show="typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 0">
              {{
                typeof call.channels !== 'undefined' &&
                  verificaLigacoes(call.channels) > 0 &&
                  selectItem(call.channels, call.callIndex)
              }}
            </i>
          </div>
        </div>
      </v-card>
    </v-row>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import monitorRamaisHttpService from '../services/monitorRamaisHttpService'

  export default {
    name: 'MonitorRamaisHome',

    data: () => ({
      livres: true,
      emLigacao: true,
      indisponiveis: false,
      ramaisFiltrados: [],
      hideButtons: true,
      aguarde: false,
      loader: null,
      user: [],
      ramaisPermitidos: [],
    }),

    computed: {
      ...mapGetters(['getRamais', 'getApiRamais']),

      getArrayRamaisFiltrados() {
        let filtrados = []
        if (this.getRamais) {
          this.getRamais.forEach(ramal => {
            if (this.ramaisPermitidos.includes(ramal.deviceId)) {
              if (this.indisponiveis && ramal.isNotRegistered) {
                filtrados.push(ramal)
              } else if (this.livres && !ramal.isNotRegistered && ramal.channels && ramal.channels.length === 0) {
                filtrados.push(ramal)
              } else if (this.emLigacao && ramal.channels && ramal.channels.length > 0) {
                filtrados.push(ramal)
              }
            }
          })
          return filtrados
        }
        return []
      },
    },

    async created() {
      const [, response] = await Promise.all([this.listarRamaisDaApi(), monitorRamaisHttpService
      .getRamaisPermitidos()])

      await this.listarRamaisDaApi()
      this.user = this.getApiRamais.ramais.map(ramal => ({
        peer: ramal.numero,
        user: ramal.usuario
      }))

      if (response.data.ramais) {
        this.ramaisPermitidos = response.data.ramais.map(ramal => ramal.numero)
      } else {
        this.ramaisPermitidos = response.data.map(ramal => ramal.numero)
      }
    },

    methods: {
      ...mapActions(['prevCall', 'nextCall', 'resetCall', 'listarRamaisDaApi']),

      selectColor(ramal) {
        if (ramal.isNotRegistered) {
          return 'app-bar-card-monitor-background-color-grey'
        }
        if (typeof ramal.channels !== 'undefined' && ramal.channels.length > 0 && ramal.channels[ramal.callIndex]
          .state) {
          if (ramal.channels[ramal.callIndex].state === 'RING' || ramal.channels[ramal.callIndex].state === 'RINGING') {
            return 'app-bar-card-monitor-background-color-orange'
          } else if (ramal.channels[ramal.callIndex].state === 'UP') {
            return 'app-bar-card-monitor-background-color-red'
          }
        }

        if (ramal.paused === '1') {
          return 'app-bar-card-monitor-background-color-yellow'
        }

        return 'app-bar-card-monitor-background-color-green'
      },

      verificaLigacoes(arrayChannels) {
        return arrayChannels.filter(channel => typeof channel.phoneNumber !== 'undefined').length
      },

      mostraTempo(arrayChannels, key) {
        if (arrayChannels.length > 0) {
          return arrayChannels[key].time
        }

        return
      },

      selectItem(arrayChannels, indexChannel) {
        let iconCall = ''
        if (typeof arrayChannels !== 'undefined' && arrayChannels[indexChannel].io === 'incoming') {
          iconCall = 'call_received'
        } else {
          iconCall = 'call_made'
        }

        return iconCall
      },

      limitaNumeroDeCaracteres(ramal) {
        let tituloCard = ''

        const indexUser = this.user.findIndex(user => user.peer === ramal)

        if (indexUser !== -1) {
          tituloCard = `${ramal} - ${this.user[indexUser].user}`

          if (tituloCard.length > 30) {
            let arrayTituloCard = tituloCard.split('')
            arrayTituloCard.splice(27)
            tituloCard = `${arrayTituloCard.join('')}...`
          }
        }

        return tituloCard
      },
    },
  }
</script>

<style scoped>
  .filter-peers {
    position: absolute;
    right: 0;
    top: 56px;

    margin-right: -12px;
    z-index: 2;
  }

  .icon-show-filters {
    font-size: 22px;
    color: var(--v-darkGray-base);

    margin-top: 4px;
    margin-left: -1px;
  }

  .icon-show-filters:hover {
    cursor: pointer;
  }

  .hide-filter-peers {
    color: var(--v-darkGray-base);
    font-size: 22px;
  }

  .hide-filter-peers:hover {
    cursor: pointer;
  }

  .filter-peers-active {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;

    width: 480px;
    height: 50px;
  }

  .app-bar-card-monitor {
    position: relative;
    width: 256px;
    height: 40px;
  }

  .app-bar-card-monitor-background-color-green {
    background-color: green;
  }

  .app-bar-card-monitor-background-color-yellow {
    background-color: #FBC400;
  }

  .app-bar-card-monitor-background-color-orange {
    background-color: var(--v-orangePcm-base);
  }

  .app-bar-card-monitor-background-color-red {
    background-color: var(--v-darkRed-base);
  }

  .app-bar-card-monitor-background-color-grey {
    background-color: var(--v-lightGray-base);
  }

  .peer-number-name {
    position: absolute;
    top: 10px;
    left: 4px;
  }

  .text-app-bar {
    font-size: 14px;
    font-weight: bold;
    color: var(--v-white-base);
  }

  .body-card-monitor {
    position: relative;
    width: 256px;
    height: 55px;
  }

  .pause-or-calls-card-monitor {
    margin: 16px -12px 0;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }

  .time-and-calls-text-card-monitor {
    color: var(--v-monitorText-base);
    font-style: italic;
    font-size: 14px;
  }

  .icons-and-calls-card-monitor {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .next-previous-call-icon {
    color: var(--v-gray-base);
  }

  .next-previous-call-icon:hover {
    cursor: pointer;
  }

  .color-icons-qtd-calls-card-body {
    color: var(--v-darkGray-base);
    font-size: 15px;
  }

  .qtd-calls-operator-card-body {
    position: absolute;
    bottom: 0;
    right: 4px;
  }

  .icon-operator-card-body {
    position: absolute;
    bottom: 5px;
    right: 18px;
  }

  /* Legenda */

  .icone-legenda {
    position: absolute;
    right: 0;
    top: 6px;

    margin-right: -12px;
    z-index: 2;
  }

  .centralizaLegenda {
    display: flex;
    align-items: center;
    justify-items: center;
  }

  .quadradoLegenda {
    font-size: 35px;
    text-shadow: 1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff;
    margin-right: 4px;
  }
</style>